import { Injectable } from '@angular/core';
import { BehaviorSubject, interval } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TimerService {
  public startTime: number = Date.now() + 1000 *60 ;
    private seconds = new BehaviorSubject<number>(0); // Starts with 0 seconds
    seconds$ = this.seconds.asObservable();
    constructor() { }   

    startTimer(duration: number = 60) {
        this.startTime = Date.now() + 1000 * duration;
        interval(1000).subscribe(() => {
            const elapsedSeconds = Math.floor((this.startTime - Date.now()) / 1000);
            if (elapsedSeconds >= 0) {
                this.seconds.next(elapsedSeconds);
            }
        })
    }
    getCurrentTime(): number {
        return this.seconds.value;
    }
}
